import { useMemo } from 'react';
/**
 * Detects whether the current browser supports WebGL rendering.
 * Prevents THREE.js from throwing "Error creating WebGL context" on
 * devices where GPU acceleration is disabled, unavailable, or blocked
 * (e.g. VMs, RDP sessions, outdated GPU drivers).
 */
export function useSupportsWebGL() {
    return useMemo(() => {
        try {
            const canvas = document.createElement('canvas');
            return !!(canvas.getContext('webgl2') || canvas.getContext('webgl'));
        }
        catch {
            return false;
        }
    }, []);
}
//# sourceMappingURL=useSupportsWebGL.js.map